module.exports = __webpack_public_path__ + "static/media/loanEstimate.7ed7d819.svg";